export default __webpack_public_path__ + "static/media/store_tencent.759bca96.svg";